import CardContainer from "./cards/cardsContainer";
import '../home/styles.css'
export default function Products(){
    return (
        <div className='margin'>
        <CardContainer></CardContainer>
        </div>
    );
}
